import { render, staticRenderFns } from "./PsAvatar.vue?vue&type=template&id=b4261dcc&scoped=true&"
import script from "./PsAvatar.vue?vue&type=script&lang=js&"
export * from "./PsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PsAvatar.vue?vue&type=style&index=0&id=b4261dcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4261dcc",
  null
  
)

export default component.exports